//Example.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Typography from "@material-ui/core/Typography";
import InsertChart from "@material-ui/icons/InsertChart";
import AddBox from "@material-ui/icons/AddBox";
import Done from "@material-ui/icons/Done";
import OpenInBrowser from "@material-ui/icons/OpenInBrowser";
import Button from "@material-ui/core/Button";
import Cache from "Cache";
import memoize from "memoize-one";

import Common from "./Common";

const styles = {
	item: {
		position: "relative",
		overflow: "hidden",
		boxShadow: "0 0 1.25em 0 rgba(0,0,0,.2)",
		transition:
			"opacity 300ms ease 0s, transform 300ms cubic-bezier(0.600, -0.280, 0.735, 0.045) 0ms, border 300ms ease 0s",
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		flexDirection: "column",
		flexWrap: "nowrap",
		backgroundColor: "white",
		border: "2px solid transparent",
		boxSizing: "border-box",
		tabIndex: "0"
	},
	itemDisabled: {
		transition: "none",
		display: "none"
	},
	topBackgroundColor: {
		position: "absolute",
		top: "0px",
		left: "0px",
		width: "100%",
		height: "120px",
		backgroundColor: "rgb(245, 245, 245)",
		zIndex: 1,
		transition: "background-color 300ms ease 0s"
	},
	itemSelectedBackground: {
		position: "absolute",
		width: "100%",
		height: "100%",
		backgroundColor: "#3f51b5",
		opacity: 0,
		zIndex: 0
	},
	itemSort: {
		lineHeight: "1.4em",
		position: "absolute",
		width: "25px",
		height: "25px",
		borderRadius: "50px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		boxSizing: "border-box",
		backgroundColor: "#ffffff",
		zIndex: "3",
		right: "7px",
		top: "7px",
		fontSize: "14px",
		color: "#999",
		transition: "background-color 300ms ease 0s, color 150ms ease 0s",
		cursor: "default"
	},
	imageContainer: {
		position: "relative",
		overflow: "hidden",
		width: "250px",
		height: "300px",
		boxShadow: "rgba(0, 0, 0, 0.05) 0px 5px 1.25em 0px",
		zIndex: 2,
		maxWidth: "100%"
	},
	image: {
		backgroundColor: "#fff",
		width: "100%",
		height: "100%",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundSize: "contain"
	},
	tagImage: {
		position: "absolute",
		top: "0px",
		right: "0px",
		Width: "60px",
		Height: "60px",
		BackgroundColor: "transparent",
		width: "30%",
		height: "30%",
		backgroundPosition: "right",
		backgroundRepeat: "no-repeat",
		backgroundSize: "contain"
	},
	quantityContainer: {
		position: "relative"
	},
	quantityButton: {
		zIndex: 10,
		position: "relative",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		color: "#3f51b5",
		padding: "8px 0px 8px 16px",
		minWidth: "88px",
		fontSize: "0.875rem",
		boxSizing: "border-box",
		minHeight: "36px",
		lineHeight: "1.4em",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		fontWeight: 500,
		borderRadius: "2px",
		textTransform: "uppercase",
		cursor: "default"
	},
	quantityDetails: {
		padding: "40px 5px 5px 5px",
		zIndex: 9,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		position: "absolute",
		top: "0px",
		left: "-57px",
		transition: "opacity 300ms ease 0s",
		width: "200px",
		backgroundColor: "white",
		boxSizing: "border-box",
		cursor: "default",
		boxShadow: "rgba(0, 0, 0, 0.1) 0px 3px 1.25em 0px",
		borderRadius: "3px",
		overflow: "hidden"
	},
	quantityDetailsValues: {
		width: "100%",
		textAlign: "center",
		maxHeight: "250px",
		overflowY: "auto"
	},
	quantityDetailsValuesText: {
		color: "rgba(0, 0, 0, 0.8)",
		fontSize: "0.75rem",
		fontWeight: "400",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight: "1.375em"
	},
	additionalAttributesContainer: {
		minWidth: "50px",
		boxSizing: "border-box",
		position: "relative",
		alignSelf: "flex-start",
		width: "250px"
	},
	additionalAttributesButton: {
		boxSizing: "border-box",
		zIndex: 8,
		position: "relative",
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		color: "rgba(0, 0, 0, 0.54)",
		padding: "8px 0 8px 16px",
		minWidth: "88px",
		fontSize: "0.75rem",
		boxSizing: "border-box",
		minHeight: "36px",
		lineHeight: "1.375em",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		fontWeight: 400,
		borderRadius: "2px",
		cursor: "default"
	},
	additionalAttributesOnItemText: {
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		marginLeft: "2px",
		width: "100%",
		overflow: "hidden"
	},
	additionalAttributesPopup: {
		maxWidth: "100%",
		padding: "5px 5px 40px 10px",
		zIndex: 7,
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		opacity: 1,
		position: "absolute",
		bottom: "5px",
		left: "10px",
		transition: "opacity 300ms ease 0s",
		width: "250px",
		backgroundColor: "white",
		boxSizing: "border-box",
		cursor: "default",
		boxShadow: "rgba(0, 0, 0, 0.1) 0px 3px 1.25em 0px",
		borderRadius: "3px",
		maxHeight: "250px",
		overflow: "hidden"
	},
	additionalAttributesPopupContent: {
		width: "100%",
		textAlign: "left",
		maxHeight: "70px",
		overflowY: "auto"
	},
	additionalAttributesPopupContentSpan: {
		fontWeight: 600,
		color: "rgb(63, 81, 181)"
	},
	additionalAttributesPopupContentValue: {
		color: "rgba(0, 0, 0, 0.54)",
		fontSize: "0.75rem",
		fontWeight: "500",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight: "1.375em"
	},
	nameContainer: {
		minHeight: "50px",
		width: "100%",
		boxSizing: "border-box",
		padding: "5px 15px",
		overflow: "hidden"
	},
	openInBrowser: {},
	preFooter: {
		display: "flex",
		height: "36px",
		justifyContent: "space-between",
		width: "100%",
		boxSizing: "border-box",
		paddingBottom: "5px"
	},
	footer: {
		backgroundColor: "#91a5b9",
		position: "relative",
		width: "100%",
		height: "50px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		color: "white",
		cursor: "default",
		overflow: "hidden"
	},
	oldPrice: {
		opacity: 0.9,
		textDecoration: "line-through"
	},
	discountPercentages: {
		position: "absolute",
		right: "5%",
		top: "0px",
		borderRadius: "0px 0px 5px 5px",
		backgroundColor: "rgba(63, 81, 181, 0.6)",
		height: "22px",
		width: "45px",
		textAlign: "center"
	}
};

const stylesActive = {
	item: {
		...styles.item,
		border: "2px solid rgb(63, 81, 181)"
	},
	itemSort: {
		...styles.itemSort,
		backgroundColor: "rgb(165, 189, 212)",
		color: "white"
	},
	topBackgroundColor: {
		...styles.topBackgroundColor,
		backgroundColor: "rgba(63, 81, 181, 0.28)"
	},
	quantityDetailsValuesText: {
		color: "rgba(0, 0, 0, 0.4)",
		fontSize: "0.75rem",
		fontWeight: "400",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight: "1.375em"
	},
	itemSelectedBackground: {
		...styles.itemSelectedBackground,
		opacity: 0.3,
		zIndex: 4
	},
	imageContainer: {
		...styles.imageContainer,
		width: "100%",
		height: "100%"
	}
};

const classes = StyleSheet.create({
	nameText: {
		color: "#777"
	},
	additionalAttributesText: {},
	priceText: {
		color: "white"
	},
	selectItemIcon: {
		position: "absolute",
		top: "17px",
		left: "36px",
		transform: "rotate(-45deg)"
	},
	addBoxIcon: {
		fontSize: "18px"
	},
	oldPriceText: {
		fontSize: "0.7rem",
		opacity: 0.9,
		fontWeight: "300",
		color: "white"
	},
	discountPercentages: {
		fontSize: "0.75rem",
		opacity: 0.9,
		fontWeight: "500",
		color: "white",
		lineHeight: "25px"
	},
	openInBrowserButton: {
		display: "flex",
		minWidth: "36px",
		maxWidth: "100%",
		justifyContent: "center",
		alignItems: "center",
		boxSizing: "border-box",
		padding: "5px",
		borderRadius: "3px",
		height: "36px",
		color: "rgba(0, 0, 0, 0.54)",
		backgroundColor: "transparent",
		cursor: "pointer",
		zIndex: 20
	},
	selectItem: {
		backgroundColor: "white",
		color: "rgb(63, 81, 181)",
		transform: "rotate(45deg)",
		position: "absolute",
		top: "-30px",
		left: "-30px",
		width: "60px",
		height: "60px",
		position: "absolute",
		zIndex: 5,
		cursor: "pointer",
		WebkitTapHighlightColor: "transparent",
		transition: "color 150ms ease 0s, background-color 300ms ease 0s",
		":hover": {
			backgroundColor: "rgb(63, 81, 181)",
			color: "white"
		}
	},
	selectItemActive: {
		backgroundColor: "rgb(63, 81, 181)",
		color: "white",
		transform: "rotate(45deg)",
		position: "absolute",
		top: "-30px",
		left: "-30px",
		width: "60px",
		height: "60px",
		position: "absolute",
		zIndex: 5,
		cursor: "pointer",
		transition: "color 150ms ease 0s, background-color 300ms ease 0s",
		WebkitTapHighlightColor: "transparent"
	}
});

class GridItem extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			itemSortChanged: false,
			showQuantityDetails: false,
			showAdditionalAttributes: false,
			buttonStyle: {},
			selectItemActive: false,
			styleChanged: false
		};

		this.oldProps = {};
		this.oldState = {};
		this.setTimeout = null;
		this.selectItemOnTouchEnd = false;
		this.selectedItemTimeout = null;
		this.showQuantityDetailsTimeout = null;
		this.showAdditionalAttributesTimeout = null;
		this.showQuantityDetails = this.showQuantityDetails.bind(this);
		this.showAdditionalAttributesOnTouch = this.showAdditionalAttributesOnTouch.bind(
			this
		);
		this.showAdditionalAttributes = this.showAdditionalAttributes.bind(
			this
		);
		this.itemOnMouseEnter = this.itemOnMouseEnter.bind(this);
		this.selectedItemOnClick = this.selectedItemOnClick.bind(this);
		this.quantityDetailsOnTouch = this.quantityDetailsOnTouch.bind(this);
		this.quantityDetailsOnTouchOff = this.quantityDetailsOnTouchOff.bind(
			this
		);

		if (this.props.item.key === 0) GridItem.items = [];
		GridItem.items.push(this);
	}

	componentDidMount() {}

	componentWillUnmount = () => {
		window.removeEventListener("resize", this.onResize);
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.item.sort != this.props.item.sort) {
			clearTimeout(this.setTimeout);
			this.setState({ itemSortChanged: true });
			this.setTimeout = setTimeout(() => {
				this.setState({ itemSortChanged: false });
			}, 1000);
		}
	}

	getImageContainerStyle = memoize((imageContainer, isNotImageMode) => {
		const imageContainerStyle =
			imageContainer != null
				? this.props.imageContainer
				: styles.imageContainer;

		const style = isNotImageMode
			? imageContainerStyle
			: stylesActive.imageContainer;
		return style;
	});

	getItemStyle = memoize((selected, itemStyle) => {
		let style = selected ? stylesActive.item : styles.item;
		style = { ...style, ...itemStyle };
		return style;
	});

	getFooterStyle = memoize(footer => {
		if (footer != null) return footer;
		return styles.footer;
	});

	getPriceTextStyle = memoize(priceText => {
		if (priceText != null) {
			const style = StyleSheet.create({
				priceText: priceText
			});
			return css(style.priceText);
		}
		return css(classes.priceText);
	});

	showQuantityDetails = toogle => event => {
		this.setState({ showQuantityDetails: toogle });
	};

	showAdditionalAttributes = toogle => event => {
		this.setState({ showAdditionalAttributes: toogle });
	};

	itemOnClick = event => {
		if (this.props.isCtrlKeyDown && this.props.isCtrlKeyDown()) {
			this.props.selectedItemOnClick(this.props.item);
		}
	};

	itemOnMouseEnter() {
		if (this.props.setLastVisitedItem)
			this.props.setLastVisitedItem(this.props.item);
	}

	selectedItemOnClick = e => {
		this.props.selectedItemOnClick(this.props.item);
		if (this.props.setLastVisitedItem)
			this.props.setLastVisitedItem(this.props.item);
	};

	renderItemSelectedBackground = memoize(toggle => {
		return (
			<div
				style={
					toggle
						? stylesActive.itemSelectedBackground
						: styles.itemSelectedBackground
				}
			/>
		);
	});

	renderSelectableItem = memoize((selectableItems, selected) => {
		if (selectableItems == false) return null;
		return (
			<div
				data-ignore="true"
				className={
					selected
						? css(classes.selectItemActive)
						: css(classes.selectItem)
				}
				onClick={this.selectedItemOnClick}
			>
				<Done
					id={"selectableItem" + this.props.item.key}
					classes={{ root: css(classes.selectItemIcon) }}
				/>
			</div>
		);
	});

	renderItemSort = memoize((showSort, itemSortChanged, isNotImageMode) => {
		if (showSort === false) return null;
		const style = itemSortChanged ? stylesActive.itemSort : styles.itemSort;
		const itemSortStyle = isNotImageMode
			? style
			: { ...style, ...{ opacity: "0.7", top: "0px", right: "0px" } };
		return (
			<div id={"itemSort" + this.props.item.key} style={itemSortStyle}>
				{this.props.item.sort}
			</div>
		);
	});

	renderTopBackgroundColor = memoize(selected => {
		return (
			<div
				style={
					selected
						? stylesActive.topBackgroundColor
						: styles.topBackgroundColor
				}
			/>
		);
	});

	quantityDetailsOnTouch() {
		clearTimeout(this.showQuantityDetailsTimeout);
		this.setState(
			{ showQuantityDetails: true },
			this.quantityDetailsOnTouchOff()
		);
	}

	quantityDetailsOnTouchOff() {
		this.showQuantityDetailsTimeout = setTimeout(() => {
			this.setState({ showQuantityDetails: false });
		}, 3000);
	}

	showAdditionalAttributesOnTouch() {
		clearTimeout(this.showAdditionalAttributesTimeout);
		this.setState(
			{ showAdditionalAttributes: true },
			this.showAdditionalAttributesOnTouchOff
		);
	}

	showAdditionalAttributesOnTouchOff() {
		this.showAdditionalAttributesTimeout = setTimeout(() => {
			this.setState({ showAdditionalAttributes: false });
		}, 3000);
	}

	openURLOnClick = (url, name) => event => {
		window.open(url, name).focus();
	};

	getFirstValueFromObject(obj) {
		for (let val in obj) return obj[val];
	}

	renderQuantityDetails = memoize((showQuantityDetails, qty, qty_view) => {
		return (
			<div
				data-key={this.props.item.key}
				style={styles.quantityContainer}
				onMouseLeave={this.showQuantityDetails(false)}
				onTouchStart={this.quantityDetailsOnTouch}
			>
				<div
					style={styles.quantityButton}
					onMouseEnter={this.showQuantityDetails(true)}
				>
					<InsertChart />
					<div style={{ marginLeft: "5px" }}>{qty}</div>
				</div>
				{showQuantityDetails && (
					<div
						id={"quantityDetails" + this.props.item.key}
						style={styles.quantityDetails}
					>
						{this.renderQuantityDetailsItems(qty_view)}
					</div>
				)}
			</div>
		);
	});

	renderQuantityDetailsItems = memoize(qty_view => {
		if (qty_view == null) return null;
		const quantityDetailsValues = Object.values(qty_view);
		const quantityDetails = quantityDetailsValues.map((e, i) => {
			return (
				<div
					key={"quantityDetailsValues" + i}
					style={
						e.in_stock
							? styles.quantityDetailsValuesText
							: stylesActive.quantityDetailsValuesText
					}
				>
					{e.label + e.qty}
				</div>
			);
		});
		return (
			<div style={styles.quantityDetailsValues}>{quantityDetails}</div>
		);
	});

	renderName = memoize(name => {
		return (
			<div style={styles.nameContainer}>
				<Typography
					data-key={this.props.item.key}
					classes={{ root: css(classes.nameText) }}
					variant="body2"
				>
					{name}
				</Typography>
			</div>
		);
	});

	renderAdditionalAttributes = memoize(
		(additional_attributes, showAdditionalAttributes) => {
			let defaultAdditionalAttribute = "";
			if (additional_attributes != null) {
				const cache_additional_attributes = Cache.settings
					.additional_attributes
					? JSON.parse(Cache.settings.additional_attributes)
					: [];
				if (
					cache_additional_attributes != null &&
					cache_additional_attributes.length > 0
				) {
					cache_additional_attributes.forEach(element => {
						if (element in additional_attributes)
							defaultAdditionalAttribute +=
								additional_attributes[element] + ", ";
					});
					defaultAdditionalAttribute = defaultAdditionalAttribute.substring(
						0,
						defaultAdditionalAttribute.length - 2
					);
				} else
					defaultAdditionalAttribute = this.getFirstValueFromObject(
						additional_attributes
					);
			}
			return (
				<div
					style={styles.additionalAttributesContainer}
					data-key={this.props.item.key}
					onMouseLeave={this.showAdditionalAttributes(false)}
					onTouchStart={this.showAdditionalAttributesOnTouch}
				>
					<div
						style={styles.additionalAttributesButton}
						onMouseEnter={this.showAdditionalAttributes(true)}
					>
						<AddBox classes={{ root: css(classes.addBoxIcon) }} />
						<div style={styles.additionalAttributesOnItemText}>
							{defaultAdditionalAttribute}
						</div>
					</div>
					{showAdditionalAttributes && (
						<div
							id={"additionalAttributes" + this.props.item.key}
							style={styles.additionalAttributesPopup}
						>
							{this.renderAdditionalAttributesPopupContent(
								additional_attributes
							)}
						</div>
					)}
				</div>
			);
		}
	);

	renderAdditionalAttributesPopupContent = memoize(additionalAttributes => {
		if (additionalAttributes == null) return null;
		let keys = Object.keys(additionalAttributes);
		additionalAttributes = keys.map((e, i) => {
			return (
				<div
					key={"additionalAttribute" + i}
					style={styles.additionalAttributesPopupContentValue}
				>
					<span style={styles.additionalAttributesPopupContentSpan}>
						{e}
					</span>{" "}
					: {e in additionalAttributes ? additionalAttributes[e] : ""}
				</div>
			);
		});

		return (
			<div style={styles.additionalAttributesPopupContent}>
				{additionalAttributes}
			</div>
		);
	});

	renderImage = memoize(
		(itemImage, tagImage, imageContainer, isNotImageMode) => {
			const style = this.getImageContainerStyle(
				imageContainer,
				isNotImageMode
			);
			const imageStyle = {
				...styles.image,
				backgroundImage: "url(" + itemImage + ")"
			};
			return (
				<div style={style}>
					<div data-key={this.props.item.key} style={imageStyle} />
					{tagImage != null && (
						<div
							style={{
								...styles.tagImage,
								backgroundImage: "url(" + tagImage + ")"
							}}
						/>
					)}
				</div>
			);
		}
	);

	renderOpenURL = memoize((url, name) => {
		return (
			<div
				id={"openURL" + this.props.item.key}
				style={styles.openInBrowser}
			>
				<Button
					color="primary"
					classes={{ root: css(classes.openInBrowserButton) }}
					onClick={this.openURLOnClick(url, name)}
				>
					<OpenInBrowser />
				</Button>
			</div>
		);
	});

	renderPreFooter = memoize(
		(additional_attributes, showAdditionalAttributes, url, name) => {
			return (
				<div style={styles.preFooter}>
					{this.renderAdditionalAttributes(
						additional_attributes,
						showAdditionalAttributes
					)}
					{this.renderOpenURL(url, name)}
				</div>
			);
		}
	);

	renderFooter = memoize(
		(special_price, price, discount_percentages, footer, priceText) => {
			const isSpecialPrice = special_price > 0;
			const isDiscountPercentages = discount_percentages != null;
			const priceSelector = isSpecialPrice ? special_price : price;
			const renderOldPrice = this.props.item.currency_symbol + price;
			const renderPriceText =
				this.props.item.currency_symbol + priceSelector;
			return (
				<div
					id={"itemPrice" + this.props.item.key}
					style={this.getFooterStyle(footer)}
				>
					{isSpecialPrice && (
						<div style={styles.oldPrice}>
							<Typography
								data-key={this.props.item.key}
								classes={{ root: css(classes.oldPriceText) }}
								variant="caption"
							>
								{renderOldPrice}
							</Typography>
						</div>
					)}
					{isDiscountPercentages && (
						<div style={styles.discountPercentages}>
							<Typography
								data-key={this.props.item.key}
								classes={{
									root: css(classes.discountPercentages)
								}}
								variant="caption"
							>
								-{discount_percentages}%
							</Typography>
						</div>
					)}
					<Typography
						data-key={this.props.item.key}
						classes={{ root: this.getPriceTextStyle(priceText) }}
						variant="body2"
					>
						{renderPriceText}
					</Typography>
				</div>
			);
		}
	);

	render() {
		if (this.props.item.disabled) return null;
		const style = this.getItemStyle(
			this.props.item.selected,
			this.props.item.style
		);
		const isNotImageMode = this.props.imageMode ? false : true;
		return (
			<div
				key={this.props.item.key}
				id={this.props.item.gridName + this.props.item.key}
				style={style}
				data-gridname={this.props.item.gridName}
				onClick={this.itemOnClick}
				onMouseEnter={this.itemOnMouseEnter}
			>
				{isNotImageMode &&
					this.renderItemSelectedBackground(this.props.item.selected)}
				{isNotImageMode &&
					this.renderSelectableItem(
						this.props.selectableItems,
						this.props.item.selected
					)}
				{this.renderItemSort(
					this.props.showSort,
					this.state.itemSortChanged,
					isNotImageMode
				)}
				{this.renderTopBackgroundColor(this.props.item.selected)}
				{isNotImageMode &&
					this.renderQuantityDetails(
						this.state.showQuantityDetails,
						this.props.item.qty,
						this.props.item.qty_view
					)}
				{this.renderImage(
					this.props.item.image,
					this.props.item.tag_image,
					this.props.imageContainer,
					isNotImageMode
				)}
				{isNotImageMode && this.renderName(this.props.item.name)}
				{isNotImageMode &&
					this.renderPreFooter(
						this.props.item.additional_attributes,
						this.state.showAdditionalAttributes,
						this.props.item.url,
						this.props.item.name
					)}
				{isNotImageMode &&
					this.renderFooter(
						this.props.item.special_price,
						this.props.item.price,
						this.props.item.discount_percentages,
						this.props.footer,
						this.props.priceText
					)}
			</div>
		);
	}
}

export default GridItem;
